import { OneTrust } from "./onetrust";
import { PracticeAnotherVersion as PAV } from "./wa/question/pav";
import { Manager as SA } from "./wa/question/student_assistant/manager";
import { WaCxpItem } from "./wa/question/cxp/item";
import { WaCxpFrame } from "./wa/question/cxp/frame";

import "./main.css";

const CXP = { Item: WaCxpItem, Frame: WaCxpFrame };

const Question = { CXP, SA, PAV };

const WA = { Question };

export { OneTrust, WA };
